module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"headerToolbarActions":{"searchTitle":"Search Purchase Order","usersManagementTitle":"Users Management","myPosListTitle":"My Assigned Purchase Orders","workloadTitle":"Subordinates Workload"}}}')
  delete Component.options._Ctor
}
